var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuestic-file-upload",
      class: `vuestic-file-upload-${_vm.type}`,
    },
    [
      _vm.type === "list"
        ? _vm._l(_vm.filesList, function (file, index) {
            return _c("vuestic-file-upload-list-item", {
              key: file.name,
              attrs: { file: file },
              on: {
                remove: function ($event) {
                  return _vm.$emit("remove", index)
                },
              },
            })
          })
        : _vm._e(),
      _vm.type === "gallery"
        ? [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.filesList, function (file, index) {
                return _c(
                  "div",
                  { key: file.name, staticClass: "flex xl2 lg3 sm4" },
                  [
                    _c("vuestic-file-upload-gallery-item", {
                      attrs: { file: file },
                      on: {
                        remove: function ($event) {
                          return _vm.$emit("remove", index)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        : _vm._e(),
      _vm.type === "single" && _vm.filesList.length
        ? _c("vuestic-file-upload-single-item", {
            attrs: {
              file: _vm.filesList[_vm.filesList.length - 1],
              isShowDelete: _vm.isShowDelete,
            },
            on: {
              remove: function ($event) {
                return _vm.$emit("remove-single")
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }